import React, { useState } from 'react';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/marketplace/HeroSection';
import { CategoryChips } from '../components/marketplace/CategoryChips';
import { RestaurantCard } from '../components/marketplace/RestaurantCard';
import { useMarketplaceData } from '../lib/hooks';
import { EmptyState } from '../components/ui/EmptyState';
import { Store } from 'lucide-react';
export function HomePage() {
  const {
    categories,
    featuredRestaurants,
    allRestaurants,
    zones,
    loading
  } = useMarketplaceData();
  const [activeCategory, setActiveCategory] = useState<string>('');
  return <div className="min-h-screen flex flex-col bg-[#0B0B0B]" data-id="element-3903">
      <MarketplaceHeader data-id="element-3904" />

      <main className="flex-1" data-id="element-3905">
        <HeroSection data-id="element-3906" />

        <div className="max-w-7xl mx-auto py-8" data-id="element-3907">
          {/* Categories */}
          {loading ? <div className="px-4 sm:px-6 lg:px-8 mb-12 flex gap-4 overflow-x-auto no-scrollbar" data-id="element-3908">
              {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-12 w-32 rounded-full shrink-0 bg-[#1a1a1a] animate-pulse" data-id="element-3909" />)}
            </div> : <div className="mb-12" data-id="element-3910">
              <CategoryChips categories={categories} activeCategory={activeCategory} onSelect={setActiveCategory} data-id="element-3911" />
            </div>}

          {/* Featured Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-3912">
            <div className="flex items-center justify-between mb-8" data-id="element-3913">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-3914">
                <span className="w-1.5 h-7 bg-[#C9A34E] rounded-full" data-id="element-3915" />
                Restaurantes Destacados
              </h2>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3916">
                {[1, 2, 3].map(i => <div key={i} className="h-[300px] rounded-2xl bg-[#1a1a1a] animate-pulse" data-id="element-3917" />)}
              </div> : featuredRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3918">
                {featuredRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-3919" />)}
              </div> : <div className="bg-[#141414] border border-white/10 rounded-2xl p-12 text-center" data-id="element-3920">
                <Store className="w-10 h-10 text-white/20 mx-auto mb-3" data-id="element-3921" />
                <p className="text-white/60 font-medium" data-id="element-3922">
                  No hay restaurantes destacados
                </p>
                <p className="text-white/30 text-sm mt-1" data-id="element-3923">
                  Vuelve pronto para descubrir nuevas opciones en tu zona.
                </p>
              </div>}
          </section>

          {/* All Restaurants Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-3924">
            <div className="flex items-center justify-between mb-8" data-id="element-3925">
              <div data-id="element-3926">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-3927">
                  <span className="w-1.5 h-7 bg-[#C9A34E] rounded-full" data-id="element-3928" />
                  Todos los Restaurantes
                </h2>
                <p className="text-sm text-white/40 mt-1 pl-5" data-id="element-3929">
                  Cada restaurante gestiona sus pedidos directamente
                </p>
              </div>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3930">
                {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-[300px] rounded-2xl bg-[#1a1a1a] animate-pulse" data-id="element-3931" />)}
              </div> : allRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3932">
                {allRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-3933" />)}
              </div> : <div className="bg-[#141414] border border-white/10 rounded-2xl p-12 text-center" data-id="element-3934">
                <Store className="w-10 h-10 text-white/20 mx-auto mb-3" data-id="element-3935" />
                <p className="text-white/60 font-medium" data-id="element-3936">
                  No se encontraron restaurantes
                </p>
                <p className="text-white/30 text-sm mt-1" data-id="element-3937">
                  Aún no hay restaurantes disponibles. Vuelve pronto.
                </p>
              </div>}
          </section>
        </div>
      </main>

      <Footer data-id="element-3938" />
    </div>;
}